import GetAppointmentsRequestModelBase from '../_generated/modelBases/get-appointments-request-model-base';

export default class GetAppointmentsRequestModel extends GetAppointmentsRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
